// @ai-generated 2026-07-10T00:00:00Z by matthias.gessinger@synqony.com using Claude Sonnet 5
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { useIdLookup } from '@Hooks/useIdLookup';
import { type ApiService } from '@Model';
import { useCallback } from 'react';
import { useListApi } from '@Hooks/useListApi';
import { ServicesRepository } from '@Repositories/Stammdaten';

export interface ServiceDetails {
    /** Map from service id to its full record. */
    detailsById: ReadonlyMap<string, ApiService>;
    /** Fetches the records of the not-yet-known service ids among the given ones and merges them in. */
    ensureDetails: (serviceIds: readonly (string | undefined)[]) => void;
}

/**
 * Fetches the full records of services by id. Used to recover fields the link into a position does
 * not carry, e.g. `decimal_places_amount` or the portal name of a material.
 */
export function useServiceDetails(): ServiceDetails {
    const { loadBatch } = useListApi(ServicesRepository, STAMMDATEN_API);

    const loadDetails = useCallback(
        async (serviceIds: string[]) => {
            const loaded = await loadBatch({
                page_no: 0,
                page_size: serviceIds.length,
                full_text_search: '',
                sort_columns: [],
                include_ids: serviceIds,
                exclude_ids: [],
            });

            return loaded.items.map((s) => [s.id, s] as const);
        },
        [loadBatch],
    );

    const { valuesById, request } = useIdLookup(loadDetails);

    return { detailsById: valuesById, ensureDetails: request };
}
